export default "__VITE_ASSET__8c0fa123__"